module.exports = __webpack_public_path__ + "img/icon_proposal_process.5e59f516.svg";